// ServiceWorkerNavigator.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ServiceWorkerNavigator() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    const handler = (event) => {
      if (event?.data?.type === 'NAVIGATE' && event.data.url) {
        const url = new URL(event.data.url);
        navigate(url.pathname + url.search + url.hash);
      }
    };
    navigator.serviceWorker.addEventListener('message', handler);
    return () => navigator.serviceWorker.removeEventListener('message', handler);
  }, [navigate]);

  return null;
}
